import { Env } from '/@/Env';

export const LoadFacebookSDKMixin = {
  static: {
    scriptElementId: 'facebook-share-sdk'
  },
  data() {
    return {
      isLoadingFacebookScript: true
    };
  },
  created() {
    this.registerShareSDKInitFn();
    this.loadShareSDK();
  },
  methods: {
    registerShareSDKInitFn() {
      if (!!window.fbAsyncInit) {
        return;
      }

      window.fbAsyncInit = function () {
        FB.init({
          appId: Env.getMetaAppId(),
          autoLogAppEvents: true,
          xfbml: true,
          version: 'v15.0'
        });
      };
    },
    loadShareSDK() {
      if (document.getElementById(this.scriptElementId)) {
        this.isLoadingFacebookScript = false;

        return;
      }

      this.appendShareSDKScriptTag();
    },
    appendShareSDKScriptTag() {
      const scriptElement = document.createElement('script');

      scriptElement.async = true;
      scriptElement.defer = true;
      scriptElement.onload = () => this.onScriptLoad();
      scriptElement.setAttribute('id', this.scriptElementId);
      scriptElement.setAttribute('crossorigin', 'anonymous');
      scriptElement.setAttribute('src', 'https://connect.facebook.net/en_US/sdk.js');

      document.body.appendChild(scriptElement);
    },
    onScriptLoad() {
      this.isLoadingFacebookScript = false;
    }
  }
};
